import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

//  -- Components ---------------------
import { Col, Row } from 'antd';
import TextEditor from 'components/TextEditor';
//  -- Constants ----------------------
import { get, map } from "lodash";
import COLOR from 'utils/constants/color';
//  -- Features -----------------------
import { Box } from '@mui/material';
import * as Sentry from '@sentry/react';
import { Modal } from "antd";
import AudioRecorder from "features/AudeoRecorderNew";
import queryString from 'query-string';
import { useDispatch } from 'react-redux';
import { usePlacementExamSession } from 'store/placement_exam/selectors';
import { handleUpdatePlacementExamSession, handleUpdatePlacementExamSessionLocal, handleUpdatePlacementExamSessionState, handleUpdatePlacementExamSubmissions } from 'store/placement_exam/thunks';
import { handleAudioTranscript } from 'store/submissions/thunks';
import { placement_next_logo, PlacementSectionNumberBg, studentQuestionImg } from "utils/assets/images";
import SectionVideoPlayer from './SectionVideoPlayer';
import PlacementInstructionBlock from './PlacementInstructionBlock';
import SentryWrap from 'components/Sentry';
import PreviewWithPlayer from 'components/UI/cloudFlare/PreviewWithPlayer';
let update_timeout =null;
let update_submission_timeout =null;

const OPTION_LABEL = ['a)', 'b)', 'c)', 'd)', 'e)']




const AssignmentTitle = styled.span`
    color: ${COLOR.black100};
    display: block;
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
    margin-bottom: 10px;
`;

const Option = styled.button`
    background-color: ${p => p.selected ? COLOR.green800 : "#ecf0f1"};
    border-radius: 3px;
    color: ${p => p.selected ? COLOR.white : COLOR.black};
    cursor: pointer;
    font-size: 16px;
    line-height: 16px;
    padding: 4px 6px;
    outline: none;
    text-align: left;
    transition: all 300ms ease;
    width: 100%;
    min-height:50px;
    border:0px;
    margin-left:10px;

    &:hover {
        box-shadow: ${p => p.selected ? 'none' : '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)'};
        color: '${p => p.selected ? COLOR.green100 : COLOR.black200}';
    }
`;
const OptionLabel = styled.span`
     color: ${COLOR.black};
     font-size: 16px;
`;
const Question = styled(AssignmentTitle)`
    font-size: 16px;
    line-height: 22px;
`;

const Wrapper = styled.div`
    max-width: 100%;
    padding: 24px 16px 0px;
    width: 100%;
    // overflow-y: auto;
    min-height: 75vh;
    max-height: 85vh;
`;
const AuidoPlayerWrapper = styled.div`
    min-width: 250px;
    max-width: 500px;
    padding:0px 16px;
    margin-bottom:10px;
    margin-top: 10px;
`;
const NextButtonWraaper = styled.button`
   cursor: ${p => !p.disabled ? "pointer" : "not-allowed"};
   display: flex;
   flex-direction: row; flex-wrap: wrap;
   border:0px;
   background: unset;
   align-self: flex-end;
`;
const ArrowButton = styled.div`
   margin-left: 14px;
`;
const ArrowImage = styled.img`
    height: 35px;
    background: #fff;
    ${({rotate})=>rotate?`transform: rotate(180deg);`:''}
`;
const NextScreenView = styled.div`
    min-height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;
const NumberContainer = styled.div`
    height: 28px;
    width: 30px;
    font-size: 19px;
    border-radius:50%;
    background-image:url(${PlacementSectionNumberBg});
    background-repeat:no-repeat;
    background-size:cover;
    background-position:center;
     display: flex;
    justify-content: center;
    align-items: center;
    color: #ffff00eb;
      text-shadow: -1px -2px 0px #1b1a1a,  
              1px -1px 0px #1b1a1a,  
             -1px  1px 0px #1b1a1a,  
              1px  1px 0px #1b1a1a;
    font-style: italic;
    margin-left: 4px;
`;

const NumberContainerSection = styled.div`
    height: 35px;
    width: 35px;
    font-size: 23px;
    border-radius:50%;
    background-image:url(${PlacementSectionNumberBg});
    background-repeat:no-repeat;
    background-size:cover;
    background-position:center;
     display: flex;
    justify-content: center;
    align-items: center;
    color: #ffff00eb;
      text-shadow: -1px -2px 0px #1b1a1a,  
              1px -1px 0px #1b1a1a,  
             -1px  1px 0px #1b1a1a,  
              1px  1px 0px #1b1a1a;
    font-style: italic;
    margin-left: 7px;

    @media screen and (max-width: 420px) {
        height: 30px;
        width: 30px;
        font-size: 20px;
    }
`;

const SectionTitle = styled.h2`
   display: flex;
   align-items: center;
   font-size: 28px;
`;

const VideoContainer = styled.div`
  width: 100%;
  margin-bottom: 0px;
//   background-color: #fff;
  border-radius: 8px;
  position: relative;
  // padding-top: 56.25%;
//   padding-top: 53.25%;

//   @media screen and (max-width: 900px) {
//     padding-top: 52%;
//   }
`;

const Fotter = styled.footer`
    display: flex;
    justify-content:${p=>p.has_back_button?"space-between":"flex-end"};
    padding: 10px 0px;
    `
const NextButton = ({ onClick = () => null, disabled , has_back_button=false ,onBackClick=()=>{} , has_completed , onMoveFinal=()=>{}}) => {
    return (<Fotter className='footerAssign' has_back_button={has_back_button}>
        {has_back_button ? <NextButtonWraaper onClick={onBackClick}>
            <div className='next-button'>
            <span>Anterior</span>
                {/* <ArrowImage src={placement_next_logo} rotate /> */}
            </div>
        </NextButtonWraaper> : null}
       {has_completed? <NextButtonWraaper onClick={onMoveFinal}>
            <div className={"next-button footerAssignDel"} style={{ backgroundColor:"#16a085",marginRight:12}} >
               Llévame al final del examen
            </div>
        </NextButtonWraaper>:null}
        <NextButtonWraaper onClick={onClick} disabled={disabled}>
            <div className={`${disabled ? "next-button-disabled" : "next-button"} footerAssignDel`} >
              Siguiente
            </div>
            {/* <ArrowButton>
                <ArrowImage src={placement_next_logo} />
            </ArrowButton> */}
        </NextButtonWraaper>
    </Fotter>)
}

const NextSectionModal = ({ onCancle, onOk, show }) => {
    return (<Modal
        className="studentQuestionModal"
        open={show}
        onCancel={onCancle}
        footer={null}
    >
        <div className="stdntModalTxt">
            <img src={studentQuestionImg} />
            <p>¿Seguro que estás listo <br /> para entregar esta sección?</p>
        </div>
        <div style={{ textAlign: "right" }}>
            <button onClick={onOk} className="next-button">Entregar y seguir</button>
        </div>
    </Modal>)
}
const handleAddedLabel = (value) => {
    if (typeof value === 'string') {
        return value.replace(/^[a-f][).]\s*/, '');
    }
    return value;
}
const Options = ({ options, answer_resonse, handleAnswerChange }) => {
    return (map(options, (option, index) => {
        return (
            <Row key={index} style={{ marginBottom: '8px', display: "flex", flexDirection: "row", alignItems: "center", flexFlow: "unset" }}>
                <OptionLabel>{OPTION_LABEL[index]}</OptionLabel>
                <Option selected={answer_resonse === index} onClick={(e) => {
                    e.preventDefault()
                    handleAnswerChange(index)
                }}>{handleAddedLabel(option)}</Option>
            </Row>
        )
    }))
}
const Player = ({ url }) => {
    return (<AuidoPlayerWrapper>
        <ReactPlayer
            url={url}
            height="40px"
            width="100%"
            controls
            playsinline
            onPlay={() => {

            }}
            onPause={() => {

            }}
            onEnded={() => { }}
            // style={{ marginBottom: '8px' }}
            config={{ file: { forceAudio: true, attributes: { controlsList: 'nodownload' } } }}
        />
    </AuidoPlayerWrapper>)
}
const PlacementExam = ({ sections, session_id , running_time }) => {
   
  	const navigate = useNavigate();
    const location = useLocation();
    const audioRef = useRef();
    const queryParams = new URLSearchParams(location.search);
      const sessionInfo = usePlacementExamSession();
      const disptch = useDispatch();
      const search = useMemo(() => queryString.parse(location.search), [location.search]);
    const initialSectionIndex = parseInt(queryParams.get("section")) || 0;
    const initialQuestionIndex = parseInt(queryParams.get("question")) || 0;
    const [sectionFinishModal, setSectionFinshModal] = useState(false);
    const [currentSectionIndex, setCurrentSectionIndex] = useState(initialSectionIndex);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(initialQuestionIndex);
    const [answers, setAnswers] = useState([]);
    const answerRef = useRef(answers);
    const has__completed = useMemo(()=>sessionInfo?.moved_to_final,[sessionInfo]);
    const [showVideoForSection1, setShowVideoForSection1] = useState(true);
    const hasAnswer = () => answers ? answers.find((answer) => answer?.some(k => k.answer!=null)) : null;
    useEffect(() => {
        answerRef.current = answers;
        const has_ans = hasAnswer()
        if (answers.length > 0 && has_ans) {
            disptch(handleUpdatePlacementExamSessionState('answers', answers))
            // updateSession()
            updateSubmission()
        }
    }, [answers])
    // session can be update..
    const updateSession = async () => {
        if (update_timeout) {
            clearTimeout(update_timeout)
        }
        update_timeout = setTimeout(async () => {
            disptch(handleUpdatePlacementExamSession('meta_data', {
                answers: answers,
                section: currentSectionIndex,
                question: currentQuestionIndex,
                running_time: running_time || 0
            }, session_id, 'submission'))
        }, 5000)
    }
    const updateSubmission = async () => {
        if (update_submission_timeout) {
            clearTimeout(update_submission_timeout)
        }
        update_submission_timeout = setTimeout(updatingAnswer, 3000)
    }
    const updatingAnswer = async () => {
        if(sessionInfo.submission?.id){
            clearTimeout(update_submission_timeout)
            disptch(handleUpdatePlacementExamSubmissions({
                answers: answerRef.current,
                completed: false,
               id:sessionInfo.submission?.id
            }))
        }
    }
    const checkHasAnswer = () => {
        if(answers&&answers.length>0&&Array.isArray(answers[0])&&answers[0][0]&&answers[0][0].answer!=null) return true;
        return false;
    }
    useEffect(() => {
        if (sessionInfo?.answers?.length > 0) {
            try {
                if(sessionInfo?.answers[0].length>0){
                    const has_data = checkHasAnswer()
                    if (!has_data&&sessionInfo?.answers) {
                        setAnswers(sessionInfo?.answers)
                    }
                }
            } catch (error) {
                Sentry.captureException(`487 Error in checkHasAnswer: ${error}`);
            }
        }
    }, [sessionInfo?.submission?.id, sessionInfo?.answers?.length])
    const [showSectionTransition, setShowSectionTransition] = useState(false);
    const [imageZoomOpen, setImageZoomOpen] = useState(false);
    const currentSection =  useMemo(()=>sections[currentSectionIndex] || {},[currentSectionIndex,sections]);
    const currentQuestion = useMemo(()=> currentSection.questions?currentSection.questions[currentQuestionIndex]:[],[currentSection,currentQuestionIndex]);

    useEffect(() => {
        if (currentSectionIndex > 0 || currentQuestionIndex > 0) {
            navigate(`/placement-exam/exam?session_id=${session_id}&section=${currentSectionIndex}&question=${currentQuestionIndex}`);
        }
    }, [currentSectionIndex, currentQuestionIndex, navigate]);
    useEffect(() => {
        if (search?.section !== undefined && search?.question !== undefined) {
            const qSectionIndex = parseInt(search.section, 10) || 0;
            const qQuestionIndex = parseInt(search.question, 10) || 0;
            if (
                currentSection?.questions &&
                qQuestionIndex < currentSection.questions.length &&
                qQuestionIndex !== currentQuestionIndex
            ) {
                setCurrentQuestionIndex(qQuestionIndex);
            }
            if (
                sections &&
                qSectionIndex < sections.length &&
                qSectionIndex !== currentSectionIndex
            ) {
                setCurrentSectionIndex(qSectionIndex);
            }
        }
    }, [search, location.search]); 
    // const handleAnswerChange = useCallback((value) => {
    //     const updatedAnswers = [...answerRef.current];
    //     if (!updatedAnswers[currentSectionIndex]) {
    //         updatedAnswers[currentSectionIndex] = [];
    //     }
    //     updatedAnswers[currentSectionIndex][currentQuestionIndex] = {
    //         answer: value,
    //         type: currentQuestion.type,
    //     };
    //     setAnswers(updatedAnswers);
    // },[answers,currentSectionIndex,currentQuestionIndex,sections]);

    const handleAnswerChange = useCallback((value) => {
        setAnswers((prevAnswers) => {
            const updatedAnswers = [...prevAnswers];
            if (!updatedAnswers[currentSectionIndex]) {
                updatedAnswers[currentSectionIndex] = [];
            }
            updatedAnswers[currentSectionIndex][currentQuestionIndex] = {
                ...updatedAnswers[currentSectionIndex][currentQuestionIndex],
                answer: value,
                type: currentQuestion.type,
                running_time: sessionStorage.getItem("remainingTime")

            };
            return updatedAnswers;
        });
    }, [currentSectionIndex, currentQuestionIndex, currentQuestion.type]);

    const handleNextQuestion = () => {
        if (currentQuestionIndex < (currentSection.questions?.length || 0) - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else {
            if (currentSectionIndex < sections.length - 1) {
                setSectionFinshModal(true)
            } else {
                moveTofinal()
            }
        }
        updatingAnswer()
    };
    const moveTofinal = () => {
        disptch(handleUpdatePlacementExamSessionLocal('moved_to_final',true))
        navigate(`/placement-exam/submissions?session_id=${session_id}`);
    }
    const handleNextSection = () => {
        setShowSectionTransition(false);
        setCurrentSectionIndex(currentSectionIndex + 1);
        setCurrentQuestionIndex(0);
    };

    if (!sections || sections.length === 0) {
        return <div>No sections available for the exam.</div>;
    }

    const closeNextModal = () => {
        setSectionFinshModal(false)
    }
    const OnOkNextModal = () => {
        setShowSectionTransition(true);
        closeNextModal()
    }


    if (showSectionTransition) {
        return (
            <>
                <div className="studentQstnContent nextMoveSection">
                    <NextScreenView>
                        <h2>You are now moving to</h2>
                        <p>Section <NumberContainerSection>{currentSectionIndex + 2}</NumberContainerSection></p>
                        {sections && sections[currentSectionIndex + 1]?.video ? 
                        <Box className="placementVideoSec">
                            <div className="placementlernModalBg">
                            <div className="modelDtl placementExamIfram">
                                <VideoContainer><PreviewWithPlayer iframeUrl={sections[currentSectionIndex + 1]?.video} style={{ position: "relative", width: "60vw" }} is_placement={true} /></VideoContainer> 
                            </div>
                            </div>
                        </Box>
                        : null}
                    </NextScreenView>
                <NextButton onClick={handleNextSection}  has_completed={has__completed} onMoveFinal={moveTofinal}/>
                </div>
            </>
        );
    }
    if (sessionInfo&&sessionInfo.start_video_url&&showVideoForSection1&&!sessionStorage.getItem(`shown_video`)) {
        return (
            <>
                <div className="studentQstnContent nextMoveSection">
                    <NextScreenView>
                        <p>Section <NumberContainerSection>1</NumberContainerSection></p>
                        {sessionInfo&&sessionInfo.start_video_url ? 
                        <Box className="placementVideoSec">
                            <div className="placementlernModalBg">
                            <div className="modelDtl placementExamIfram">
                                <VideoContainer><PreviewWithPlayer iframeUrl={sessionInfo&&sessionInfo.start_video_url} style={{ position: "relative", width: "60vw"}} is_placement={true} /></VideoContainer>
                            </div>
                            </div>
                        </Box>
                         : null}
                    </NextScreenView>
                <NextButton onClick={()=>{
                    setShowVideoForSection1(false)
                    sessionStorage.setItem(`shown_video`,true)
                    }}  has_completed={has__completed} onMoveFinal={moveTofinal}/>
                </div>
            </>
        );
    }


    const trenacriptAudio = (url) => {
        if (url) {
            handleAudioTranscript(url)
        }
    }

    if (!currentQuestion) {
        return <div>No questions available in this section.</div>;
    }
    const isDisabled = () =>{
        if(answers&&answers[currentSectionIndex]&&answers[currentSectionIndex][currentQuestionIndex]){
            const ans  = answers[currentSectionIndex][currentQuestionIndex].answer;
            if(ans == 0 ){
                return false;
            } else if(ans == null || ans == ""){
                return true;
            }else{
                return false;
            }
        }
      return true;
    }
    let answer_resonse = answers[currentSectionIndex]?.[currentQuestionIndex]?.answer
    answer_resonse = answer_resonse == 0 ? 0 : answer_resonse || ""
    const disabled_next = isDisabled()
    return (
    <SentryWrap>
        <Wrapper>
            <NextSectionModal show={sectionFinishModal} onCancle={closeNextModal} onOk={OnOkNextModal} />
            <div className="studentQstnContent">
                <div className="instructions">
                    <SectionTitle className="placementSectionTitle">
                        Section <NumberContainer>{currentSectionIndex + 1}</NumberContainer> <SectionVideoPlayer videoUrl={currentSection?.video} is_placement={true} />
                    </SectionTitle>
                    <PlacementInstructionBlock
                        sectionInstruction={currentSection?.instruction}
                        questionInstruction={currentQuestion.instruction}
                    />
                </div>

                {currentSection?.audio ? <Player url={currentSection.audio} /> : null}
                {currentSection?.image ? (
                    <>
                        <ImageZoomWrap onClick={() => setImageZoomOpen(currentSection?.image)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && setImageZoomOpen(true)}>
                            <Image src={currentSection.image} alt="section image" style={{ cursor: "zoom-in", marginBottom: "15px" }} />
                        </ImageZoomWrap>
                        <Modal
                            open={currentSection.image === imageZoomOpen}
                            onCancel={() => setImageZoomOpen("")}
                            footer={null}
                            width="max-content"
                            styles={{ body: { padding: 16, display: 'flex', justifyContent: 'center', alignItems: 'center' } }}
                            centered
                        >
                            <ZoomedImage src={currentSection.image} alt="section image zoom" />
                        </Modal>
                    </>
                ) : null}
                {currentQuestion.question ? <Question>{currentQuestion.question?`${currentQuestionIndex+1})`:null}<span style={{marginLeft:"10px"}}>{currentQuestion.question}</span></Question> : null}
                {currentQuestion.image ? (
                    <>
                        <ImageZoomWrap onClick={() => setImageZoomOpen(currentQuestion?.image)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && setImageZoomOpen(true)}>
                            <Image src={currentQuestion.image} alt="question image" style={{ cursor: "zoom-in", marginBottom: "10px" }} />
                        </ImageZoomWrap>
                        <Modal
                            open={currentQuestion?.image === imageZoomOpen}
                            onCancel={() => setImageZoomOpen("")}
                            footer={null}
                            width="max-content"
                            styles={{ body: { padding: 16, display: 'flex', justifyContent: 'center', alignItems: 'center' } }}
                            centered
                        >
                            <ZoomedImage src={currentQuestion?.image} alt="question image zoom" />
                        </Modal>
                    </>
                ) : null}
                {currentQuestion.type === "multipleChoice" && (<Options options={get(currentQuestion, "options", [])} answer_resonse={answer_resonse} handleAnswerChange={handleAnswerChange} />)}
                {currentQuestion.type === "essay" && (
                    <Row gutter={[0, 24]}>
                        <Col span={24} style={{ border: "1px solid #8080806e" }}>
                            <TextEditor
                                handleChange={data => handleAnswerChange(data)}
                                key={`${currentSectionIndex}-${currentQuestionIndex}`} 
                                value={answer_resonse}
                                has_limited_option
                                disableWordSuggestions
                                containerStyle={{ minHeight: '300px', maxHeight: "60vh" }}
                            />
                        </Col>
                    </Row>
                )}
                {currentQuestion.type === "audio" && (
                    <>
                        <Player url={currentQuestion.audio} />
                        <AudioRecorder
                            ref={audioRef}
                            key={`${currentSectionIndex}-${currentQuestionIndex}-audio`} 
                            maxTime={currentQuestion.duration || 20}
                            handleAudio={url => {
                                handleAnswerChange(url)
                                trenacriptAudio(url)
                            }}
                            index={currentQuestionIndex}
                            refresh={() => navigate(0)}
                            wrapperStyle={{ maxWidth: "500px", borderBottom: "0px" }}
                            source={answer_resonse}
                        />
                    </>
                )}
                {currentQuestion.type === "audio_multichoice" && (
                    <div>
                        <Player url={currentQuestion.audio} />
                        <Options options={get(currentQuestion, "options", [])} answer_resonse={answer_resonse} handleAnswerChange={handleAnswerChange} />
                    </div>
                )}
                {currentQuestion.type === "audio_written_response" && (
                    <div>
                        <Player url={currentQuestion.audio} />
                        <Row gutter={[0, 24]}>
                            <Col span={24} style={{ border: "1px solid #8080806e" }}>
                                <TextEditor
                                    handleChange={data => handleAnswerChange(data)}
                                    key={`${currentSectionIndex}-${currentQuestionIndex}`} 
                                    value={answer_resonse}
                                    has_limited_option
                                    disableWordSuggestions
                                    containerStyle={{ minHeight: '300px', maxHeight: "60vh" }}
                                />
                            </Col>
                        </Row>
                    </div>
                )}
                {currentQuestion.type === "trueFalse" && <Options options={get(currentQuestion, "options", [])} answer_resonse={answer_resonse} handleAnswerChange={handleAnswerChange} />}
            <NextButton onClick={handleNextQuestion} disabled={disabled_next}  has_back_button={currentQuestionIndex>0} 
            has_completed={has__completed}
            onMoveFinal={moveTofinal}
            onBackClick={()=>{
                setCurrentQuestionIndex(currentQuestionIndex-1)
            }}/>
            </div>
        </Wrapper>
    </SentryWrap>
    );
};

export default PlacementExam;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
    max-height: 190px;
`;

const ImageZoomWrap = styled.div`
    cursor: pointer;
    display: inline-block;
    max-width: 100%;
`;

const ZoomedImage = styled.img`
    max-width: 90vw;
    max-height: 85vh;
    width: auto;
    height: auto;
    object-fit: contain;
`;